module.exports = __webpack_public_path__ + "static/img/logoHTN.2c5792f3.jpg";